import { useDrawdownRepaymentSchedule } from '@api/lendingAPI/lapiHooks';
import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { getOfferInterestRate } from '@helpers/FormalOffers/getOfferInterestRate';
import { getDurationInMonths } from '@helpers/GetDurationInMonths/getDurationInMonths';
import { getMinMonthlyRepaymentAmount } from '@helpers/RepaymentSchedule/getMinMonthlyRepaymentAmount';

export function useLoanSummary(
    formalOffer: TFormalOffer,
    drawdownAmount: number
) {
    const offerId = formalOffer.offer_id;

    const { data: schedule } = useDrawdownRepaymentSchedule({
        offerId: offerId ?? '',
        drawdownAmount,
        enabled: Boolean(offerId) && Boolean(drawdownAmount),
        suspense: true
    });

    return {
        drawdownAmount,
        monthlyRepayment: schedule
            ? (getMinMonthlyRepaymentAmount(schedule) ?? 0)
            : 0,
        interestRate: getOfferInterestRate(formalOffer) ?? 0,
        withdrawalFeePercentage: formalOffer.withdrawal_fee_percentage ?? 0,
        fullTermMonths: formalOffer.duration
            ? getDurationInMonths(formalOffer.duration)
            : 0
    };
}
